declare const BUILD_TIME: string

export function getRecurrenceFreq(recurrence: string): string | null {
  if (!recurrence || !recurrence.includes('RRULE:')) return recurrence;

  const match = recurrence.match(/FREQ=.*/)

  return match ? match[0] : null;
}

export function isGuid(guid: string): boolean {
  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(guid)
}

export function browserSupportsInputType(type: string): boolean {
  const input = document.createElement('input')
  input.setAttribute('type', type)
  return input.type === type
}

// create link tag to load css-bundle
export function loadStyleBundle(bundleName: string): void {
  const style = document.createElement('link')
  style.id = bundleName
  style.rel = 'stylesheet'
  style.href = bundleName + '.css?v=' + BUILD_TIME

  // cancel if the stylesheet was already loaded
  if (document.querySelector('link[id="' + bundleName + '"]'))
    return

  document.getElementsByTagName('head')[0].appendChild(style)
}


// source: https://github.com/Cordobo/angularx-qrcode/blob/main/projects/demo-app/src/app/app.component.ts#L216C3-L231C4
export function convertBase64ToBlob(Base64Image: string) {
  // split into two parts
  const parts = Base64Image.split(";base64,")
  // hold the content type
  const imageType = parts[0].split(":")[1]
  // decode base64 string
  const decodedData = window.atob(parts[1])
  // create unit8array of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length)
  // insert all character code into uint8array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i)
  }
  // return blob image after conversion
  return new Blob([uInt8Array], { type: imageType })
}
